import { templateSizeGuide } from './size-guide/templateSizeGuide';
import { launchCustomEvent } from '../../common/customEvent';

/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-const-assign */
/* eslint-disable no-plusplus */
export const checkIconProduct = () => {
  let iconList = [];
  /* eslint-disable global-require */
  /* eslint-disable no-else-return*/
  if (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    iconList = require('./json/iconProductsList.json');
    iconList.forEach(element => {
      if(element && element.product === parseInt(window.tc_vars.product_id_model,10)){
        removeExpressCheckout();
        changeTimeDeliveryIcon();
      }});

  } else {
    fetch('/static/json/iconProductsList.json')
      .then(response => response.json())
      .then(json => {
        json.forEach(element => {
          if(element && element.product === parseInt(window.tc_vars.product_id_model,10)){
            removeExpressCheckout();
            changeTimeDeliveryIcon();
          }});
      }).catch(() => {
      // Error :(
      });
  }
};

export const removeExpressCheckout = () => {
  jQuery('.cart-buttons #express-payment-cta').remove();

};

export const changeTimeDeliveryIcon = () => {
  jQuery('.leadtime-display__content').html('Entrega en 7 días');
};

export const evaluateSimulator = () => {

  if (window.tc_vars.product_currentprice_ati > 90 && window.tc_vars.product_currentprice_ati <= 2500) {
    simulatorDropdown();
  }
};

export const simulatorDropdown = () => {
  let apiBaseUrl = '';
  if (window.tc_vars.env_work === 'preprod' || window.location.origin.indexOf('slots-ux') >= 0) {
    apiBaseUrl = 'https://formulario-preprod.decathlon.net/';
  } else {
    apiBaseUrl = 'https://formulario.decathlon.net/';
  }

  function thousands_separators(num) {
    const num_parts = num.toString().split('.');
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return num_parts.join(',');
  }

  function cleanSimulation() {
    if (jQuery('.es-financiacion').length > 0) {
      jQuery('.es-financiacion').remove();
    }
    if (jQuery('.es-simulation').length > 0) {
      jQuery('.es-simulation').remove();
    }
    if (jQuery('.es-text-total').length > 0) {
      jQuery('.es-text-total').remove();
    }
    if (jQuery('.es-text-apertura').length > 0) {
      jQuery('.es-text-apertura').remove();
    }
  }
  function activeSimulation() {
    let isLoading = false;
    const timestamp = new Date().getTime();

    if (window.tc_vars.product_currentprice_ati > 90 && window.tc_vars.product_currentprice_ati <= 2500) {
      cleanSimulation();
      //Get info price product to next call api oney: window.tc_vars.product_currentprice_ati
      jQuery('body').addClass('es-main-financement');

      let meses = [3, 4, 6, 10];
      const variable = [];
      const priceFinal = jQuery('#current-price-container .dkt-price__cartridge').data('price');

      if (priceFinal > 90 && priceFinal <= 119.99) {
        meses = [3, 4];
      } else if (priceFinal >= 120 && priceFinal <= 199.99) {
        meses = [3, 4, 6];
      } else if (priceFinal >= 200 && priceFinal <= 2500) {
        meses = [3, 4, 6, 10];
      }


      // eslint-disable-next-line vars-on-top
      const valueMeses = ['001', '001', '001', '01'];

      // eslint-disable-next-line no-inner-declarations
      function getSimulationOne() {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < meses.length; i++) {
          jQuery.ajax({
            type: 'GET',
            dataType: 'json',
            async: false,
            url: `${apiBaseUrl}financing.php?price=${priceFinal}&month=${meses[i]}x${valueMeses[i]}`,
            cache:true,
            // eslint-disable-next-line no-loop-func
          }).done((json) => {
            const finished = new Date().getTime();
            if(finished > timestamp + 10000) {
              isLoading = true;
            }
            const data = json;
            variable.push(data);
          })
          // eslint-disable-next-line no-loop-func
            .fail(() => {
              isLoading= true;
            })
            // eslint-disable-next-line no-loop-func
            .error(() =>{
              isLoading = true;
            });
        }
      }
      getSimulationOne();
      if(isLoading === false) {
        const month = 3;
        if (variable.length > 0) {
          jQuery('#conversion-zone .dkt-price__cartridge').after(`<span class='es-financiacion'> Por </span>`);
        }

        // eslint-disable-next-line func-names
        jQuery('body').on('click', '#myDropdown a', function () {
          const month = jQuery(this).data('type');
          const tae = jQuery(this).data('tae');
          const price = jQuery(this).data('price');
          const total = jQuery(this).data('total');
          const admin = jQuery(this).data('admin');
          const child = jQuery(this).data('index');
          jQuery('.es-simulation').remove();
          jQuery('.es-text-total').remove();
          jQuery('.es-text-apertura').remove();
          getSimulationInfo(month, variable, price, child, meses);
          jQuery('.es-simulation .es-simulation button').html(`<span class='es-price'>${thousands_separators(price)}€/mes</span> en <span class='es-months'>${month} cuotas</span>`);
          jQuery(`<div class='es-text-total'><span title='info' class='icon icon-i-line'></span><span class='es-underline-financiacion'>A plazos: </span> &nbsp Total adeudado &nbsp<span class='financiacion-value'>${thousands_separators(total)}€</span>&nbsp | TAE  &nbsp<span class='financiacion-value'>${thousands_separators(tae)}%</span> </div>`).insertAfter('#conversion-zone .dkt-price');
          jQuery(`<div class='es-text-apertura'>Gastos de gestión &nbsp<span class='financiacion-value'>${admin.toString().replace('.', ',')}€</span>&nbsp a incluir en la 1ª cuota</div>`).insertAfter('.es-text-total');
          jQuery('.es-simulation').find('#myDropdown').toggleClass('show');

          cube.analytics.sendEvent(this, 'NavigationEvent', 'ProductPage - Conversion', 'simulador_pago', `${month} cuotas`, '');
        });

        // eslint-disable-next-line no-inner-declarations
        function getSimulationInfo(number, param, price, child, meses) {

          let priceSimulation = 0;

          if (price > 0) {
            priceSimulation = price;
          } else {
            priceSimulation = param[0].instalments[1].instalment_amount;
          }

          let dropDownHtml = `<div class='es-simulation dropdown'>
                        <button class='dropbtn' style='color: black;'>
                            <span class='es-price'>${priceSimulation}€/mes</span> en <span class='es-months'>${number} cuotas</span>
                        </button>
                        <div id='myDropdown' class='dropdown-content'>`;

          let cont;
          for (cont = 0; cont < param.length; cont++) {
            if (typeof param !== 'undefined' && param[cont].payment_amount) {
              dropDownHtml += `<a data-type="${meses[cont]}" data-index="${cont}" data-admin="${param[cont].administration_fee_amount}" data-total="${param[cont].total_cost}" data-price="${param[cont].instalments[1].instalment_amount}" data-tae="${param[cont].effective_annual_percentage_rate}"><b>${thousands_separators(param[cont].instalments[1].instalment_amount)}€/mes</b> en <b>${meses[cont]} cuotas</b></a>`;
            }
          }

          dropDownHtml = dropDownHtml.concat(`</div></div>`);

          jQuery('.es-financiacion').after(dropDownHtml);

          if (child > 0) {
            jQuery(`#myDropdown a[data-index="${child}"]`).addClass('active');
          }
        }

        // eslint-disable-next-line no-inner-declarations
        function deploySimulator() {
          jQuery('body').on('click', '.es-simulation', (event) => {
            event.stopPropagation();
            jQuery('.es-simulation').find('#myDropdown').toggleClass('show');
          });
          jQuery('body').on('click', () => {
            jQuery('.es-simulation').find('#myDropdown').removeClass('show');
          });

        }

        deploySimulator();
        if (variable.length > 0) {
          jQuery(`<div class='es-text-total'><span title='info' class='icon icon-i-line'></span><span class='es-underline-financiacion'>A plazos:</span>&nbsp Total adeudado &nbsp<span class='financiacion-value'>${thousands_separators(variable[0].total_cost)}€</span>&nbsp | TAE  <span class='financiacion-value'>&nbsp${thousands_separators(variable[0].effective_annual_percentage_rate)}%</span>&nbsp </div>`).insertAfter('#conversion-zone .dkt-price');
          jQuery(`<div class='es-text-apertura'>Gastos de gestión &nbsp<span class='financiacion-value'>${thousands_separators(variable[0].administration_fee_amount)}€</span>&nbsp a incluir en la 1ª cuota</div>`).insertAfter('.es-text-total');
          //take out the % of the sale price
          jQuery('.product-price-and-button .dkt-price__info-addon').insertBefore('.product-price-and-button .dkt-price.dkt-price--promo');
          getSimulationInfo(month, variable, 0, 0, meses);
        }
      }
    }
  }

  activeSimulation();

  jQuery('body').on('click', '.product-models .model-selection, .js-product-sizer li', () => {
    // eslint-disable-next-line func-names
    setTimeout(() => {
      activeSimulation();
      jQuery('body').on('click', '.es-simulation', () => {
        jQuery('.es-simulation').find('#myDropdown').toggleClass('show');
      });

    }, 500);
  });

};

export const isLocalOrEphemeral = () => (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0);

export const sizeGuide = () => {

  if (window.tc_vars.env_template === 'product'){
    const element = jQuery('#conversion-zone').find('.sizes__size--solo-sku');
    if (element.length>0){
      jQuery('body').addClass('hideSizeLink');
    }
  }

  // eslint-disable-next-line no-unused-expressions
  // eslint-disable-next-line func-names
  if (window.tc_vars.env_template === 'product' && jQuery('.sizes__wrapper').attr('data-usize') !== 'true') {
    jQuery('.choose-link').html('<a href="#" class="cta-link">Guia de tallas</a>');
    jQuery('body').append('<input type="checkbox" class="modalv2__toggler" id="es-js-modal-test">\n<div class="modalv2 es-modalv2">\n<label for="es-js-modal-test" class="modalv2__overlay"></label>\n<div class="es-modalv2-container">Guia de Tallas</div>\n</div>');
    jQuery(document).on('click', '.choose-link .cta-link:not(.fitanalytics__button), .sizes__size .cta-link:not(.fitanalytics__button)', () => {
      let pathSizeGuide = '';

      if (isLocalOrEphemeral()) {
        let sizeGuideHTML='';
        let fullTemplateSizeGuideWithScript='';
        const pathScriptSizeGuideFTP='<script src="https://www.decathlon.es/static/landings/guia-de-tallas/js/functions.js"></script>';
        sizeGuideHTML = templateSizeGuide();
        fullTemplateSizeGuideWithScript=`${sizeGuideHTML}${pathScriptSizeGuideFTP}`;

        setTimeout(() => {
          jQuery('.es-modalv2-container').html(fullTemplateSizeGuideWithScript);
          jQuery('.es-modalv2-container').prepend('<div class="close">X</div>');
          jQuery('.es-modalv2-container').closest('.es-modalv2').addClass('opened-modal');
          jQuery('body.product-page').css('overflow-x', 'unset');
        },200);

      } else {
        pathSizeGuide = '/static/landings/guia-de-tallas/guia-tallas.htm';
        jQuery('.es-modalv2-container').load(pathSizeGuide, () => {
          jQuery('.es-modalv2-container').prepend('<div class="close">X</div>');
          jQuery('.es-modalv2-container').closest('.es-modalv2').addClass('opened-modal');
          jQuery('body.product-page').css('overflow-x', 'unset');
        });
      }

    });

    jQuery('body').on('click', '.es-modalv2-container .close', () => {
      jQuery('.es-modalv2-container').closest('.opened-modal').removeClass('opened-modal');
    });

    jQuery(document).click((e) => {
      const modalContainer = jQuery('.es-modalv2-container');
      modalContainer.is(e.target) || modalContainer.has(e.target).length !== 0 || (jQuery('.es-modalv2-container').closest('.opened-modal').css('visibility', 'hidden'), jQuery('.es-modalv2-container').closest('.opened-modal').removeClass('opened-modal'));
    });
    // eslint-disable-next-line no-sequences
  }
};

export const customProduct = (addStockStoreBlueButton) => {
  function initialize() {
    // eslint-disable-next-line no-sequences
    jQuery('body').addClass('es-custom-product');
    //move above the avis and product code
    jQuery('.container-notation-ref').insertAfter('.title--main.product-title-right');
    addStockStoreButton(addStockStoreBlueButton);
    tagButtonStock();
    customizeProduct();
    decorateProductNav();
    customizeImageSlider();
    addAvis();
    stickerReacondicionados();
    jQuery(window).width() <= 800 && unexpandSlots();
    // eslint-disable-next-line func-names
    jQuery(window).scroll(function () {
      jQuery(this).width() > 800 && decorateProductNav();
    });
    jQuery(window).resize(() => {
      decorateProductNav();
    });
  }

  function stickerReacondicionados() {
    if (jQuery('#sticker-display-div em').html() === 'REACONDICIONADO') {
      jQuery('#sticker-display-div em').css('font-size', '14px');
      jQuery('#sticker-display-div em').css('font-weight', '400');
    }
  }

  function addAvis() {

    const avis = window.tc_vars.product_rating;
    if (avis !== 0) {
      jQuery(`<div class="es-avispp">${avis}/5</div>`).insertBefore('.notation-stars');
      jQuery('.icon.icon-arrow1-d.view-review').remove();

      if (jQuery(window).width() <= 1024) {
        jQuery('.product-refs').insertAfter('.container-notation-ref');
      }
    }
  }



  function tagButtonStock() {
    jQuery('.es-stock-store').on('click', () => {
      let labelEvent = 'ok';
      if (jQuery('.sizes__stock-quantity.stock-infos__message > span').length > 0) {
        labelEvent = 'ok';
      } else {
        labelEvent = 'ko_talla';
      }
      cube.analytics.sendEvent(this, 'NavigationEvent', 'ProductPage', 'dispo_tienda', labelEvent, '');
    });
  }


  function customizeProduct() {

    // eslint-disable-next-line no-sequences
    jQuery('#product-question-answer').remove();
    jQuery('.leadtime-display.leadtime-display--visible').insertAfter('#js-sizes-layout');
    jQuery('.sizemeter-notation.sizemeter-resume').remove();
  }

  function customizeImageSlider() {

    // eslint-disable-next-line radix
    const totalPictures = parseInt(jQuery('.product-picture__counter-total').text());
    // eslint-disable-next-line no-sequences
    if (totalPictures > 8) {

      if (jQuery('.media-zoom__thumbnail--video').length) {
        addVideoPhoto();

      }
      jQuery('.product-picture__arrow.product-picture__arrow--top.icon').css('display', 'none');
      jQuery('.product-picture__arrow.product-picture__arrow--bottom').css('display', 'none');

      const productThumbnail = jQuery('.product-picture__thumbnail-nav');
      // eslint-disable-next-line no-sequences

      jQuery('.product-picture__counter').css({display: 'none'});
      productThumbnail.append('<a href="#picture-0-7" class="js-toggle-media-zoom show-more"><span title="Mostar mas imagenes" class="icon icon-plus-line"></span></a>');

      // eslint-disable-next-line func-names
      jQuery('.product-picture__thumbnail-nav a.show-more').hover(function () {
        // eslint-disable-next-line no-sequences
        jQuery(this).find('span').removeClass('icon-plus-line');
        jQuery(this).find('span').addClass('icon-plus-roll');
        // eslint-disable-next-line func-names
      }, function () {
        // eslint-disable-next-line no-sequences
        jQuery(this).find('span').removeClass('icon-plus-roll');
        jQuery(this).find('span').addClass('icon-plus-line');
      });
    }
  }

  function addVideoPhoto() {
    const videoThumbnail = jQuery(jQuery('.media-zoom__thumbnail--video')[0]).clone();
    const photoThumbnail = jQuery(jQuery('.product-picture__thumbnail')[6]);
    const imgVideoThumbnail = videoThumbnail.find('img');
    const imgDataSource = imgVideoThumbnail.attr('data-src');
    // eslint-disable-next-line no-sequences
    jQuery('button.product-picture__video-toggler').css({display: 'none'});
    videoThumbnail.insertAfter(photoThumbnail);
    videoThumbnail.addClass('product-picture__video-toggler js-toggle-media-zoom product-picture__video-toggler--visible product-video-thumbnail-picture');
    imgVideoThumbnail.attr('data-loaded', !0);
    imgVideoThumbnail.addClass('js-img-lazy-loaded');
    imgVideoThumbnail.attr('src', imgDataSource);
  }

  function unexpandSlots() {
    // eslint-disable-next-line func-names
    jQuery('#ProductDetailsFloorsContentSlot > div').each(function () {
      // eslint-disable-next-line no-undef
      const btnSlot = jQuery(this).find('.btn-collapse');
      jQuery(this).is('#BundleFloor') || (btnSlot.attr('aria-expanded') === 'false' && btnSlot.trigger('click'));
    });
  }

  initialize();
};
export function addStockStoreButton(addStockStoreBlueButton) {
  if($('#shopStockButton').length === 0 && addStockStoreBlueButton) {
    jQuery('<div id="shopStockButton" class="cart-buttons cart-buttons--store"><button class="cta-v2 cta-v2--alt js-open-store-selector" data-icon=">">VER EL STOCK EN LA TIENDA</button></div>').insertAfter('#conversion-zone .stock-notification__invite-toggler');
    if (jQuery('.stock-infos i').attr('data-tnr-out-of-stock') === '' && jQuery('.stock-notification__invite.stock-notification__invite--active').lengh === 0){
      jQuery('<div id="shopStockButton" class="cart-buttons cart-buttons--store"><button class="cta-v2 cta-v2--alt js-open-store-selector" data-icon=">">VER EL STOCK EN LA TIENDA</button></div>').insertAfter('#conversion-zone .stock-infos');
    }
  }
  jQuery('.es-stock-store').click(() => {
    if (isCurrentModelSizeSelected()) {
      jQuery('.es-stock-store').addClass('js-open-store-selector');
    } else {
      jQuery('.es-stock-store').removeClass('js-open-store-selector');
      window.displayError(window.Messages('pdm.pleaseSelectSize'), window.Consts.MAIN_ERROR);
    }
  });
  if(addStockStoreBlueButton){
    setTimeout(activateButtons,100);
  }

  jQuery(window).resize(() => {
    decorateProductNav();
  });
}
function decorateProductNav() {
  if (jQuery(this).width() > 800) {
    const scrollDistance = $(window).scrollTop() - jQuery('.description-product-nav').height() - jQuery('#product-head').height() - 500;
    // eslint-disable-next-line func-names
    jQuery('.description-product-nav .description-product-nav--visible').each(function (index) {
      jQuery(jQuery(this).find('a').attr('href')).position().top <= scrollDistance && (jQuery('.active-description').removeClass('active-description'), jQuery('.description-product-nav .description-product-nav--visible').eq(index).addClass('active-description'));
    });
  }
}

function isCurrentModelSizeSelected() {
  function getSelectedModelIndex() {
    let selectedModelIndex = -1;
    if (jQuery('.sizes__wrapper.sizes__wrapper--visible .sizes__size.sizes__size--selected').length || jQuery('.sizes__wrapper .sizes__size--solo-sku.sizes__size--selected').length) {
      selectedModelIndex = 1;
    }
    return selectedModelIndex;
  }

  const currentItemIndex = getSelectedModelIndex();

  // If there's an item selected and a size is selected for that item.
  if (currentItemIndex !== -1) {
    return true;
  }

  return false;
}

export const initCheckSticker = () => {
  if (checkPVPRsticker()) {
    changeMainPVPRstyle();
  }
  changeSliderPVPRstyle();
};

export const changeMainPVPRstyle = () => {
  const sticker = jQuery('.product-picture__container .dkt-product__sticker__sticker');
  if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!') {
    const element = jQuery('#conversion-zone .dkt-price .dkt-price__price-reco');
    // get current price
    const currentPrice = jQuery('#conversion-zone .dkt-price .dkt-price__cartridge').data('price');
    // get pvpr price from string and convert to float
    let stringPrice = element.html().split('€')[1];
    if (window.location.origin.indexOf('localhost') >= 0) {
      stringPrice = stringPrice.replace('.,', ',');
    }
    let decimalPrice = stringPrice.split(',')[0];
    decimalPrice = decimalPrice.split('.').join('');
    const centPrice = stringPrice.split(',')[1].split('<span')[0];
    const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
    // get product discount
    const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);
    element.remove();
    jQuery('#conversion-zone .product-price').prepend(`<span class="dkt-price__info-addon"><span class="dkt-price__previous-price" style="text-decoration: none;">PVPR €${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction"> -${discountPercentage}%</span></span>`);
  } else {
    jQuery('#conversion-zone .dkt-price .dkt-price__price-reco').remove();
    jQuery('#conversion-zone .dkt-price .dkt-price__legal-addon').remove();
  }
};

export const changeSliderPVPRstyle = () => {
  jQuery('.pl-list--cross-sell .plv2-element').each(
    function checkPVPR() {
      const sticker = jQuery(this).find('.dkt-product__sticker__sticker');
      const element = jQuery(this).find('.dkt-price .dkt-price__price-reco');
      if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!' && element.length > 0) {
        // get current price
        const currentPrice = jQuery(this).find('.dkt-price .dkt-price__cartridge').data('price');
        // get pvpr price from string and convert to float
        let stringPrice = element.html().split('€')[1];
        if (window.location.origin.indexOf('localhost') >= 0) {
          stringPrice = stringPrice.replace('.,', ',');
        }
        let decimalPrice = stringPrice.split(',')[0];
        decimalPrice = decimalPrice.split('.').join('');
        const centPrice = stringPrice.split(',')[1].split('<span')[0];
        const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
        // get product discount
        const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);
        element.remove();
        jQuery(this).find('.plv2-el__price a').prepend(`<span class="dkt-price__info-addon"><span class="dkt-price__previous-price" style="text-decoration: none;">PVPR €${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction"> -${discountPercentage}%</span></span>`);
      } else {
        jQuery(this).find('.dkt-price .dkt-price__price-reco').remove();
        jQuery(this).find('.dkt-price .dkt-price__legal-addon').remove();
      }
    }
  );
};

export const checkPVPRsticker = () => jQuery('#conversion-zone .dkt-price .dkt-price__price-reco').length > 0;

const idsSizesSizeScope = [];
const idsSizesSizeCookieScope = [];

export const printButtonAddToCart = (activates) => {

  /* CHECK IF THE IS STOCK, IF NOT DISABLE THE BUTTON */
  // if($('.sizes__wrapper.sizes__wrapper--visible .sizes__size[data-available-quantity!="0"]').length === 0){
  //   $('#pdp-add-to-cart').attr('disabled',true);
  // }

  try {
    nonExistentElements();
    initStickyFooterCart(activates);

  } catch (error) {
    console.error('Error sticky footer - override.js');
  }

};

function isExist(value) {
  if (value === false || value === null || value === 0 || value === '') {
    return false;
  }
  return value;
}

function nonExistentElements() {
  try {
    nonExistentElement('#container-top');
    nonExistentElement('#current-price-container');
    nonExistentElement('.stock-infos');
  } catch (error) {
    // eslint-disable-next-line no-throw-literal
    throw 'non Existent Element Html List';
  }
}

function nonExistentElement(elementHtml) {
  if (!$(elementHtml).length) {
    // eslint-disable-next-line no-throw-literal
    throw 'non Existent Element Html';
  }
}

function initStickyFooterCart(activates) {
  try {
    if (jQuery(window).width() <= 800) {
      printStickyAddToCart(activates.addStockStoreButton);
    }

    if(activates.cookieSelectSize) {
      cookieSelectSize();
    }

    if ($('.sizes__wrapper--visible').length) {
      const elementIdSize = $('.sizes__wrapper--visible [aria-selected=true]').data('id');
      const textSize = $(
        '.sizes__wrapper.sizes__wrapper--visible .sizes__list [aria-selected=true] .sizes__info'
      ).text();
      $(`.sizes__size[data-id="${elementIdSize}"]`).click();

      $(`.sizes__size[data-id="${elementIdSize}"]`)
        .parents('.sizes__wrapper')
        .find('.sizes__button')
        .html(
          `<div class="cookie-size">${textSize}  <span class="cookie_pdp_size"> - Según tus compras anteriores</span></div>`
        );

    }

  } catch (error) {
    console.error('error init Sticky Footer');
  }
}

export function initListeners(addStockStoreBlueButton) {
  listenerChangeModel(); // listen when change the color product
  priceChangeListener(); // listen when change price product
  listenerChangeStock(addStockStoreBlueButton); // listen when change the color product
  listenerAvailableStore(addStockStoreBlueButton); // listen when there's no online stock
  listenerCloseModal(); // listen when close the modal
}

function printStickyAddToCart(addStockStoreBlueButton) {
  const template = `<div id="pdp-add-to-cart-bottom" class="add__to__cart__bottom">
    <div class="pdp__close__dialog">
      <span class="icon icon-x"></span>
    </div>
    <div id="pdp-colors"></div>
    <div id="pdp-sizes"></div>
    <div class="price__and__button">
        <div class="pdp__price"></div>
        <button id="pdp-add-to-cart" class="cta-v2 cta-v2--no-break dkti-cart">AÑADIR A LA CESTA</button>
    </div>
  </div>`;

  $('#container-top').append(template);
  enabledButtonAddToCart();
  updatePriceProductInStickyFooter();
  /* need refactor */
  listenerPDPAddToCart();
  initListeners(addStockStoreBlueButton);
}

function enabledButtonAddToCart() {
  const existStockModelProduct = $(
    '#conversion-zone .sizes__wrapper .sizes__size[data-quantity="true"]'
  );
  if (existStockModelProduct.length === 0) {
    $('#pdp-add-to-cart').attr('disabled', 'disabled');
  }
}

function updatePriceProductInStickyFooter() {
  const currentPriceProductBlockHtml = $('#current-price-container')[0]
    .innerHTML;
  $('.add__to__cart__bottom .pdp__price').html(currentPriceProductBlockHtml);
  removePriceHtml();
}

function removePriceHtml() {
  $('.price__and__button .dkt-price__legal-addon').remove();
  $('.price__and__button .es-text-total').remove();
  $('.price__and__button .es-text-apertura').remove();
  $('.price__and__button .es-simulation').remove();
  $('.price__and__button .es-financiacion').remove();
}

function priceChangeListener() {
  $('#current-price-container').bind('DOMSubtreeModified', () => {
    updatePriceProductInStickyFooter();
  });
}

function listenerChangeModel() {
  $('.model-selection').click(selectSizeListEvent);
}

function selectSizeListEvent(event) {
  const textInitSelect = $(
    '.sizes__wrapper--visible [aria-selected=true] .sizes__info'
  ).text();
  const currentModelId = $(event.target).parent().parent().data('modelId');
  $(`.sizes__wrapper[data-id="${currentModelId}"] .sizes__list li`).each(
    function () {
      idsSizesSizeCookieScope.forEach((elementIdSize) => {
        if (elementIdSize === $(this).data('id')) {
          $(`.sizes__size[data-id="${elementIdSize}"]`).click();
          const textSize = $(this).parent().parent().find('.sizes__button').text();
          const currentelementIdSize = elementIdSize;
          event.stopPropagation();
          $(`.sizes__size[data-id="${currentelementIdSize}"]`)
            .parents('.sizes__wrapper')
            .find('.sizes__button')
            .html(
              `<div class="cookie-size">${textSize}  <span class="cookie_pdp_size"> - Según tus compras anteriores</span></div>`
            );

        }
      });
    }
  );
  controlStatusButtonAddToCart();
}

function sizeClickEvent() {
  const existStockModelProduct = $('.sizes__wrapper.sizes__wrapper--visible');
  if (existStockModelProduct.length) {
    const modelCurrentProduct = $(
      '.sizes__wrapper.sizes__wrapper--visible'
    ).data('id');
    $(`.model-selection[data-model-id="${modelCurrentProduct}"]`).click(
      selectSizeListEvent
    );
  }
}

function listenerAvailableStore(addStockStoreBlueButton) {
  if(!$('.stock-notification__invite').is(':visible')) {
    addStockStoreButton(addStockStoreBlueButton);
  }
  if($('.stock-notification__invite').is(':visible') && $('.stock-infos').is(':visible')) {
    setTimeout(activateButtons,100);
  }
}

function listenerChangeStock(addStockStoreBlueButton) {
  $('.stock-infos').bind('DOMSubtreeModified', () => {
    controlStatusButtonAddToCart(addStockStoreBlueButton);
  });
}

function showStockButtonAdded(){
  if (jQuery('.stock-notification__invite.stock-notification__invite--active').length === 0){
    $('#shopStockButtonAdded').css('display','flex');
  }
  else{
    $('#shopStockButtonAdded').css('display','none');
  }
}

function activateButtons (){
  // #ctaButton is identifier of yellow button with name add to cart.
  if($('#ctaButton').is(':disabled') || $('#ctaButton').hasClass('disabled')){
    if($('#shopStockButtonAdded').length<1 && jQuery('.stock-notification__invite.stock-notification__invite--active').length === 0){
      jQuery('<div id="shopStockButtonAdded" class="cart-buttons cart-buttons--store"><button class="cta-v2 cta-v2--alt js-open-store-selector" data-icon=">">VER EL STOCK EN LA TIENDA</button></div>').insertAfter('.stock-infos');
    }
    showStockButtonAdded();
    $('#ctaButton').css('display', 'none');
  }
  else{
    $('#shopStockButtonAdded').css('display', 'none');
    $('#ctaButton').css('display', 'flex');
  }
}

function controlStatusButtonAddToCart(addStockStoreBlueButton) {
  let enableButton=true;
  //Compruebo que hay stock de ese producto y que el producto no está bloqueado desde BCC. Si hay al menos 1 talla con stock, activo el botón
  if($('.sizes__wrapper').length > 1){
    if ($('.sizes__wrapper.sizes__wrapper--visible').length>0){
      enableButton = $('.sizes__wrapper.sizes__wrapper--visible .sizes__size[data-quantity="true"] .sizes__stock__info').length > 0;
    }
    else{
      enableButton = $('.sizes__wrapper .sizes__size--selected[data-quantity="true"] .sizes__stock__info').length > 0;
    }
  }
  else{
    enableButton = $('.sizes__wrapper .sizes__size[data-quantity="true"] .sizes__stock__info').length > 0;
  }
  if(enableButton) {
    $('#pdp-add-to-cart').removeClass('disabled cta-v2--disabled');
    $('#pdp-add-to-cart').prop('disabled', false);
  } else {
    $('#pdp-add-to-cart').addClass('disabled cta-v2--disabled');
    $('#pdp-add-to-cart').prop('disabled', true);
  }
  addStockStoreButton(addStockStoreBlueButton);
}
function printSliderModel() {
  if (window.tc_vars.product_id_article.length > 1) {
    const sliderModel = createSliderModel();
    if (sliderModel[1] > 1) {
      $('#pdp-colors').html(sliderModel[0]);
      refreshSliderModel(sliderModel[1]);
      $('.item__pdp__slider__colors, .pdp__slider__colors .slick-arrow').click(
        () => {
          rePrintSizesbox();
        }
      );
    }
  }
}

function printSliderSizes(model) {
  if ($('.sizes__wrapper li').length > 0) {
    const slider = createSliderSize(model);
    $('#pdp-sizes').html(slider[0]);
    refreshSliderSize(slider[1], slider[2]);
    $('#pdp-sizes').css('display', 'block');
  }
}

function checkProductAtributes() {
  return (
    $('.sizes__size--solo-sku.sizes__size--selected').length > 0 ||
    ($('#conversion-zone .sizes__wrapper.sizes__wrapper--visible') &&
      $('body').hasClass('showDialogV1'))
  );
}

function listenerPDPAddToCart() {
  $('#pdp-add-to-cart').click(() => {
    //sizes__size sizes__size--solo-sku sizes__size--selected
    if (checkProductAtributes()) {
      addToCart();
    } else {
      $('body').addClass('showDialogV1');
      $('.go-to-top.top_link').css('z-index', '6999');
      showModelsAndSizes();

      const dataId = $('.sizes__wrapper--visible [aria-selected=true]').data(
        'id'
      );
      $('.item__pdp__slider__sizes').removeClass('selected');
      $(`#pdp-slider-sizes [data-id="${dataId}"]`).addClass('selected');
    }
  });
}

function showModelsAndSizes() {
  $('.pdp__close__dialog').css('display', 'block');

  if ($('.model-selection.slick-current').length !== 0) {
    printSliderModel();
    const position = $('.model-selection.slick-current').data('slick-index');
    $(`.item__pdp__slider__colors[data-slick-index=${position}]`).click();
    $('#pdp-colors').css('display', 'block');
  }
  if ($('.sizes__wrapper.sizes__wrapper--visible').length > 0) {
    // model Color Product
    const model = $('.sizes__wrapper.sizes__wrapper--visible').data('id');
    printSliderSizes(model);
  } else {
    $('#pdp-add-to-cart').addClass('disabled cta-v2--disabled');
  }

  jQuery('.size-link-float').on('click', () => {
    if (jQuery('#conversion-zone').find('#fitanalytics__button').length > 0) {
      jQuery('#conversion-zone #fitanalytics__button').click();
    } else {
      jQuery('#conversion-zone #size-selector-title .cta-link').click();
    }
  });
}

function listenerCloseModal() {
  $('.pdp__close__dialog span').click(() => {
    hideItemsModal();
  });

  $('#pdp-add-to-cart-bottom').click((e) => {
    e.stopPropagation();
  });

  $('html').click((e) => {
    if (
      e.target.className.indexOf('sizes__size') === -1 &&
      e.target.className.indexOf('model-selection') === -1 &&
      e.target.className.length > 1
    ) {
      hideItemsModal();
    }
  });
}

function hideItemsModal() {
  $('.pdp__close__dialog').css('display', 'none');
  $('#pdp-colors').css('display', 'none');
  $('#pdp-sizes').css('display', 'none');
  jQuery('body').removeClass('showDialogV1');
  $('.go-to-top.top_link').css('z-index', '');
}

function createSliderModel() {
  let listColor = '';
  let numModel = 0;
  $('.model-selection').each(function () {
    const mainElement = jQuery(this);
    const model = mainElement[0].dataset.modelId;
    const numSizes = $(`.sizes__wrapper[data-id=${model}] li`).length;
    const numSizesLeft = $(
      `.sizes__wrapper[data-id=${model}] li[data-available-quantity="0"]`
    ).length;

    if (numSizes > numSizesLeft) {
      numModel++;
      const imgModel = $(mainElement).find('img')[0].currentSrc;
      listColor += `<div style="background-image:url(${imgModel});" class="item__pdp__slider__colors" data-id="${model}"></div>`;
    }
  });

  let itemsHtml = numModel > 0 ? '<div>Color</div>' : '';
  itemsHtml += `<div id="pdp-slider-color" class="pdp__slider__colors small">`;
  itemsHtml += `${listColor}</div>`;
  return [itemsHtml, numModel];
}

function createSliderSize(model) {
  let listSizes = '';
  let widthText = 0;
  let contSizes = 0;

  $(`.sizes__wrapper[data-id=${model}] li[data-available-quantity!="0"]`).each(
    function () {
      const mainElement = jQuery(this);
      const dataId = mainElement[0].attributes[1].nodeValue;
      // eslint-disable-next-line no-plusplus
      contSizes++;
      const textSize = mainElement[0].childNodes[1].innerText;
      idsSizesSizeScope.push(dataId);
      if (
        $(
          '.sizes__wrapper.sizes__wrapper--visible .sizes__list [aria-selected=true] .sizes__info'
        ).text() === textSize
      ) {
        listSizes += `<div class="item__pdp__slider__sizes selected" data-id="${dataId}">${textSize}</div>`;
      } else {
        listSizes += `<div class="item__pdp__slider__sizes" data-id="${dataId}">${textSize}</div>`;
      }
      if (textSize.length > widthText) {
        widthText = textSize.length;
      }
    }
  );
  let displaySizes = 'none';
  let itemsHtml = '';
  if (contSizes > 0) {
    displaySizes = '';
    itemsHtml +=
      '<div class="block-size-titles"><div class="size-title">Talla</div><div class="size-link-float">¿Qué talla elegir?</div></div>';
  }
  itemsHtml += `<div id="pdp-slider-sizes" class="pdp__slider__sizes small" style="display: ${displaySizes};">`;
  itemsHtml += `${listSizes}</div>`;

  return [itemsHtml, contSizes, widthText];
}

function refreshSliderSize(contSizes, widthText) {
  const widthSlider = $('#pdp-slider-sizes').width();
  const widthSize = widthText * 5 + 32;

  let configSlider = {
    dots: false,
    infinite: false,
    draggable: true,
    swipeToSlide: true,
    focusOnSelect: true,
    variableWidth: true,
  };
  if (widthSlider - 30 > contSizes * widthSize) {
    configSlider = {
      dots: false,
      swipeToSlide: true,
      infinite: false,
      draggable: true,
      focusOnSelect: true,
      slidesToShow: contSizes,
      slidesToScroll: 1,
    };
  }
  $('.pdp__slider__sizes').on('init', (slick) => {
    $('.item__pdp__slider__sizes').click(() => {
      const model = $('.item__pdp__slider__sizes.slick-current').data('id');
      $('.item__pdp__slider__sizes').removeClass('selected');
      $('.item__pdp__slider__sizes.slick-current').addClass('selected');

      // Update select Body Size
      $(`.sizes__size[data-id=${model}]`).click();
      const selectCurrentBody = $(
        '.sizes__wrapper--visible [aria-selected=true]'
      ).data('id');
    });
  });
  $('.pdp__slider__sizes').not('.slick-initialized').slick(configSlider);
}

function refreshSliderModel(numModel) {
  const widthSlider = $('#pdp-slider-color').width();
  let configSlider = {
    dots: false,
    infinite: false,
    draggable: true,
    swipeToSlide: true,
    focusOnSelect: true,
    variableWidth: true,
    slickGoTo: 1,
  };
  if (widthSlider - 30 > numModel * 48) {
    configSlider = {
      dots: false,
      infinite: false,
      draggable: true,
      swipeToSlide: true,
      focusOnSelect: true,
      variableWidth: false,
      slidesToScroll: 1,
      slidesToShow: numModel,
      slickGoTo: 1,
    };
  }
  $('.pdp__slider__colors').not('.slick-initialized').slick(configSlider);
  $('.pdp__slider__colors').on('swipe', (event, slick, direction) => {
    rePrintSizesbox();
  });
}

function rePrintSizesbox() {
  const modelCurrentStickyProduct = $(
    '.item__pdp__slider__colors.slick-current'
  ).data('id');

  $('.model-selection.slick-current').removeClass('slick-current');
  $(`.model-selection[data-model-id=${modelCurrentStickyProduct}]`).addClass(
    'slick-current'
  );
  $(`.sizes__wrapper [data-id="${modelCurrentStickyProduct}"]`).addClass(
    '.sizes__wrapper--visible'
  );
  printSliderSizes(modelCurrentStickyProduct);
}

function addToCart() {

  const formData = new FormData();
  const productId = window.tc_vars.product_id_super_model;
  let catalogId = 0;
  let quantitySizeSelectedBody = 0;
  let quantitySizeSelectedSticky = 0;


  if ($('.sizes__wrapper--visible [aria-selected=true]').length) {
    const sizeId = $('.sizes__wrapper--visible [aria-selected=true]').data('id');
    quantitySizeSelectedBody = $(`.sizes__size[data-id="${sizeId}"]`).data(
      'quantity'
    );
  }
  if ($('.item__pdp__slider__sizes.selected').length) {
    const sizeId = $('.item__pdp__slider__sizes.selected').data('id');
    quantitySizeSelectedSticky = $(`.sizes__size[data-id="${sizeId}"]`).data(
      'quantity'
    );
  }

  if (
    !quantitySizeSelectedBody > 0 &&
    !quantitySizeSelectedSticky > 0 &&
    $('.sizes__size--solo-sku.sizes__size--selected').length === 0
  ) {
    return false;
  }

  if ($('.sizes__wrapper--visible [aria-selected=true]').length > 0) {
    if (
      typeof $('.model-selection.slick-current').data('modelId') === 'undefined'
    ) {
      catalogId = $('.sizes__wrapper--visible [aria-selected=true]').data('id');
    }
    if ($('.item__pdp__slider__sizes.selected').length) {
      catalogId = $('.item__pdp__slider__sizes.selected').data('id');
    }
  }

  if (catalogId === 0 &&
    $('.sizes__size--solo-sku.sizes__size--selected').length === 0) {
    return false;
  }

  if ($('.sizes__size--solo-sku.sizes__size--selected').length > 0) {
    catalogId = $('.sizes__size--solo-sku.sizes__size--selected').data('id');
  }

  const enviroment = window.tc_vars.env_work;

  let host;
  let numSection;

  if (enviroment === 'prod') {
    numSection = 9876312;
    host = 'www.decathlon.es';
  }

  if (enviroment === 'preprod') {
    numSection = 9876311;
    host = window.location.host;
  }

  if (enviroment === 'local') {
    numSection = 9876312;
    host = 'localhost:9000';
  }

  const url = `https://${host}/es/ajax/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder`;

  try {
    formData.append('catalogRefIds', catalogId);
    formData.append('productId', productId);
    formData.append('quantity', 1);

    const request = new XMLHttpRequest();
    request.onreadystatechange = function (event) {
      if (request.readyState === XMLHttpRequest.DONE) {
        addItemToIconCart();
        showMessageAddToCart();
        hideItemsModal();
      }
    };

    request.open('POST', url);
    request.send(formData);

    cube.analytics.sendEvent(
      this,
      'NavigationEvent',
      'ProductPage - Conversion',
      'AddToCart_sticky',
      productId,
      ''
    );
  } catch (error) {
    console.error('Error sticky footer - override.js');
  }

  launchCustomEvent('es-add-to-cart');

  return true;
}

function addItemToIconCart() {
  const actualValue = parseInt($('#cartItemsCount').html(), 10);
  $('#cartItemsCount').html(actualValue + 1);
}

function showMessageAddToCart() {
  const addToCartConfirm = document.getElementsByClassName(
    'add-to-cart-confirm'
  )[0];
  addToCartConfirm.style.display = 'block';
  addToCartConfirm.style.width = '100%';
  addToCartConfirm.style.top = '106px';
  $('#add-to-cart-confirm-icon-error').remove();
  setTimeout(() => {
    addToCartConfirm.style.display = 'none';
  }, 3000);
}

function activatedStockInfoProduct() {
  $('#ctaButton').removeClass('cta-v2--disabled');
  $('#ctaButton').removeClass('disabled');
  $('#ctaButton').attr('disabled', false);
  $('#express-payment-cta').removeClass('cta-v2--disabled');
  $('#express-payment-cta').removeClass('disabled');
  $('#express-payment-cta').attr('disabled', false);
}

class Cookie {
  static create(cookieName, cookieValue, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);

    const cookie = [
      `${cookieName}=${JSON.stringify(
        cookieValue
      )}; expires=${date}.toGMTString(); path=/`,
    ].join('');
    document.cookie = cookie;
  }

  static get(cookieName) {
    const name = `${cookieName}=`;
    const allCookieArray = document.cookie.split(';');
    for (let i = 0; i < allCookieArray.length; i += 1) {
      let temp = allCookieArray[i].trim();
      while (temp.charAt(0) === '') {
        temp = temp.substring(1, temp.length);
      }
      if (temp.indexOf(name) === 0) {
        return JSON.parse(temp.substring(name.length, temp.length));
      }
    }
    return false;
  }
}

export const cookieSelectSize = () => {

  const cookieName = `PDP_SIZE`;
  jQuery('#ctaButton, #pdp-add-to-cart').click(() => {
    const pageName = window.tc_vars.page_name;
    const pag_names = pageName.split('/');
    const category_0 = pag_names[2].split('-')[0].toUpperCase();
    const gender = [
      'hombre',
      'mujer',
      'ninos',
      'nina',
      'nino',
      'bebe',
      'junior',
    ];
    let category_1 = '';
    for (let i = 0; i < gender.length; i += 1) {
      if (pag_names[2].split('-').indexOf(gender[i]) !== -1) {
        category_1 = gender[i].toUpperCase();
      }
    }
    const category = `${category_0} ${category_1}`;
    const value = Cookie.get(cookieName);
    clickCtaButton(category, value, cookieName);
  });

  checkCookie(cookieName);

  function updateCookie(value, key) {
    let enc = false;
    let index = 0;
    let arrValue = Array.isArray(value) ? value : [value];

    if (arrValue.length > 0) {
      while (index < arrValue.length && !enc) {
        if (arrValue[index].category === key.category) {
          enc = true;
          if (key.size.toString().indexOf('cookie-size') !== -1) {
            arrValue[index].size = key.size
              .toString()
              .split('cookie-size">')[1]
              .split('<span')[0]
              .trim();
          } else {
            arrValue[index].size = key.size;
          }
        }
        index += 1;
      }
      if (!enc) {
        arrValue = [...arrValue, key];
      }
    }

    return arrValue;
  }

  function checkCookie(name) {
    const pageName = window.tc_vars.page_name;
    const pag_names = pageName.split('/');
    const category_0 = pag_names[2].split('-')[0].toUpperCase();
    const gender = [
      'hombre',
      'mujer',
      'ninos',
      'nina',
      'nino',
      'bebe',
      'junior',
    ];
    let category_1 = '';
    for (let i = 0; i < gender.length; i += 1) {
      if (pag_names[2].split('-').indexOf(gender[i]) !== -1) {
        category_1 = gender[i].toUpperCase();
      }
    }
    let category = `${category_0} ${category_1}`;
    if ($('.sizes__list li .sizes__info').length &&
      !parseInt(jQuery(jQuery('.sizes__list li .sizes__info')[0]).text(), 10)
    ) {
      category = `${category}-TEX`;
    }
    let value = Cookie.get(name);
    value = Array.isArray(value) ? value : [value];
    if (value === '' && value.length === 0) {
      return false;
    }
    const filter = value.filter(isExist).filter((e) => e.category === category);
    if (!filter.length) {
      return false;
    }
    if (selectSizeCookiePdp(filter[0].size)) {
      jQuery('.sizes__button').html(
        `<div class="cookie-size">${filter[0].size}  <span class="cookie_pdp_size"> - Según tus compras anteriores</span></div>`
      );


      CUBE.Analytics.setDimension('cd75', 'talla_rec', filter[0].size);
    }

    return true;
  }

  function clickCtaButton(category, value, name) {

    let size = 0;

    if (jQuery('.sizes__button').length > 0) {
      size = jQuery('.sizes__button').html().trim();
      if (!parseInt(size, 10)) {
        category = `${category}-TEX`;
      }
    }
    const key = {
      category,
      size,
    };

    let valueCookie = '';
    if (value !== '') {
      valueCookie = updateCookie(value,
        key);
    } else {
      valueCookie = key;
    }
    Cookie.create(name, valueCookie, 730);
    cube.analytics.sendEvent(
      this,
      'NavigationEvent',
      'add_cart',
      'talla',
      size,
      ''
    );
  }

  function selectSizeCookiePdp(stringSizeModel) {
    let isSelected = false;
    // eslint-disable-next-line func-names
    //.sizes__wrapper.sizes__wrapper--visible
    //'.sizes__wrapper.sizes__wrapper--visible .sizes__list li .sizes__info'

    jQuery('.sizes__list li .sizes__info').each(function () {
      if (jQuery(this).text() === stringSizeModel) {
        const selectedSizes = jQuery(this)[0].parentElement;
        idsSizesSizeCookieScope.push($(selectedSizes).data('id'));

        jQuery(selectedSizes).addClass('sizes__size--selected');
        jQuery(selectedSizes).attr('aria-selected', true);

        if(jQuery(this).siblings().find('span.sizes__stock__info.sizes__stock__info--nostock').length === 0){
          $('#ctaButton').addClass('cta-v2--disabled');
          $('#ctaButton').addClass('disabled');
          $('#ctaButton').attr('disabled', true);
          $('#express-payment-cta').addClass('cta-v2--disabled');
          $('#express-payment-cta').addClass('disabled');
          $('#express-payment-cta').attr('disabled', true);
        }
        isSelected = true;
      }
    });

    return isSelected;
  }
};





// WEBPACK FOOTER //
// ./src/_override/shared/pdp/es-pdp-functions.js